// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-markdown {
  gap: 24px;
  display: flex;
  flex-direction: column;
  
  ul, ol {
      margin: 0;
      padding: 0;
      list-style: none;
  }

  li {
      line-height: 24px;
      font-size: 16px;
      color: white;
  }
  
  ul li {
      margin-top: 4px;
      margin-bottom: 4px;
      display: flex;
      align-items: center;
  }

  ul li::before {
      content: "";
      width: 4px;
      height: 4px;
      margin-right: 16px;
      background-color: rgba(255, 255, 255, 0.25);
      border-radius: 2px;
  }

  ol li {
      counter-increment: step-counter;
  }
  
  ol li::before {
      content: counter(step-counter) ".";
      color: #ffffff80;
      margin-top: 1px;
      min-width: 8px;
      display: inline-block;
      margin-right: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./../src/screen/Summary/markdown.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;;EAEtB;MACI,SAAS;MACT,UAAU;MACV,gBAAgB;EACpB;;EAEA;MACI,iBAAiB;MACjB,eAAe;MACf,YAAY;EAChB;;EAEA;MACI,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,mBAAmB;EACvB;;EAEA;MACI,WAAW;MACX,UAAU;MACV,WAAW;MACX,kBAAkB;MAClB,2CAA2C;MAC3C,kBAAkB;EACtB;;EAEA;MACI,+BAA+B;EACnC;;EAEA;MACI,kCAAkC;MAClC,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,qBAAqB;MACrB,kBAAkB;EACtB;AACF","sourcesContent":[".summary-markdown {\n  gap: 24px;\n  display: flex;\n  flex-direction: column;\n  \n  ul, ol {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n  }\n\n  li {\n      line-height: 24px;\n      font-size: 16px;\n      color: white;\n  }\n  \n  ul li {\n      margin-top: 4px;\n      margin-bottom: 4px;\n      display: flex;\n      align-items: center;\n  }\n\n  ul li::before {\n      content: \"\";\n      width: 4px;\n      height: 4px;\n      margin-right: 16px;\n      background-color: rgba(255, 255, 255, 0.25);\n      border-radius: 2px;\n  }\n\n  ol li {\n      counter-increment: step-counter;\n  }\n  \n  ol li::before {\n      content: counter(step-counter) \".\";\n      color: #ffffff80;\n      margin-top: 1px;\n      min-width: 8px;\n      display: inline-block;\n      margin-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
